import { BaseEntity } from 'src/app/tools/models/baseEntity';


export class ProductAnalysisGroup1 extends BaseEntity {

  productAnalysisGroup1Code : string;
  name                      : string;
  rank                      : string;
   
}